import { Badge } from 'components/shared/Badge.styled';
import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledCompanies = styled.div`
  background-color: ${color('midnight_850')};
  padding-top: ${spacing('xl2')};
  padding-bottom: ${spacing('xl2')};
  color: ${color('text_default_inverse')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  margin: auto;

  ${Heading2} {
    text-align: center;
  }
`;

export const StyledFeatures = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('xl')};
  margin-top: ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    align-items: initial;
  }
`;

export const StyledFeature = styled.div`
  background-color: ${color('midnight_800')};
  padding: ${spacing('xl')};
  max-width: 25rem;

  @media (min-width: ${screen('md')}) {
    width: 33.333%;
    max-width: unset;
  }

  ${Badge} {
    margin-top: ${spacing('md')};
  }
`;

export const StyledFeatureIcon = styled.img`
  display: block;
  width: 5rem;
  height: 5rem;
`;

export const StyledFeatureTitle = styled.h6`
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('extraBold')};
  margin-top: ${spacing('xl')};
  margin-bottom: ${spacing('md')};
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -${spacing('md')};
    left: 0;
    width: ${spacing('xl')};
    height: ${spacing('xs2')};
    background-color: ${color('cyan_300')};
  }
`;

export const StyledFeatureDesc = styled.p`
  margin: 0;
`;
